import type { ExerciseKind, FirstCardNote, TrainingResult } from '../model';
import { SessionScreen } from './SessionScreen';

interface MobileSessionProps {
  onExit: () => void;
  /** Совместимость со старыми входами в тренировку. */
  cram?: boolean;
  /** Модуль cram-сессии (для резюма по cram-дорожке, она per-module). */
  moduleId?: string;
  /** Выход после просмотра результатов. */
  onFinish?: () => void;
  /** Свой экран итогов вместо Completion (знакомство). */
  onComplete?: (result: TrainingResult) => void;
  /** Подсказка до первого ответа (знакомство) — по виду упражнения первой карточки. */
  firstCardNote?: FirstCardNote;
  /** Первая карточка — этим упражнением (знакомство: выбор из вариантов). */
  firstExercise?: ExerciseKind;
}

/** Мобильная тренировка: та же сцена, но инструменты ответа вынесены из
 *  пилюли в отдельный ряд под большой палец, а клавиатурные подписи скрыты.
 *  Клавиатура нативная — док стоит в потоке и не дерётся с ней за низ экрана. */
export function MobileSession({ onExit, cram, moduleId, onFinish, onComplete, firstCardNote, firstExercise }: MobileSessionProps) {
  return (
    <SessionScreen
      onExit={onExit}
      variant="mobile"
      cram={cram}
      moduleId={moduleId}
      onFinish={onFinish}
      onComplete={onComplete}
      firstCardNote={firstCardNote}
      firstExercise={firstExercise}
    />
  );
}
